import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';

export const componentKey = "FORMS/LISTING";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setFiltersLoadingState: (state, action) => {
            state.filtersLoadingState = action.payload;
        },
        setFormsList: (state, action) => {
            state.formsList = action.payload;
        },
        setTaxYearsList: (state, action) => {
            state.taxYearsList = action.payload;
        },
        setPayersList: (state, action) => {
            state.payersList = action.payload;
        },
        setFormType: (state, action) => {
            state.formType = action.payload;
        },
        setFormStatus: (state, action) => {
            state.formStatus = action.payload;
        },
        setFillingType: (state, action) => {
            state.fillingType = action.payload;
        },
        setSubmittedForms: (state, action) => {
            state.submittedForms = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },
        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setCalculateTaxFeeModalOpen: (state, action) => {
            state.calculateTaxFeeModalOpen = action.payload;
        },
        setSelectedForms: (state, action) => {
            state.selectedReadyToSubmitForms = action.payload
        },
        setIsCheckBoxChecked: (state, action) => {
            const { name, index, checked } = action.payload
            state.submittedForms[index][name] = checked
        },
        setViewTin:(state)=>{
            state.isTINHidden = !state.isTINHidden
        },
        setIsAllCheckBoxChecked: (state, action) => {
            const { name, checked } = action.payload;

            state.submittedForms.map(form => {
                if (name == "IsEmailRecipient" && (form.RecipientEmail == "No email address" || !form?.TIN)) {
                    return form[name] = false;
                } else if (name == "IsTinCheck" && !form?.TIN) {
                    return form[name] = false;
                } else if (name == "IsState" && !form?.State) {
                    return form[name] = false;
                } else {
                    return form[name] = checked;
                }
            })
        },
        setDeleteFormsModalOpen: (state, action) => {
            state.deleteFormsModal = action.payload
        },
        setFormDetailsDrawerOpen: (state, action) => {
            state.fromDetailsDrawerOpen = action.payload
        },
        setHighlightedForm: (state, action) => {
            state.highlightedForm = action.payload
        },
        setFormDetails: (state, action) => {
            state.formDetails = action.payload
        },
        setSubmittedFormsDetails: (state, action) => {
            state.submittedFormsDetails = action.payload;
        },
        setReadyToSubmitTabCheckboxes: (state, action) => {
            state.readyToSubmitTabCheckboxes = { ...state.readyToSubmitTabCheckboxes, ...action.payload }
        },
        setSumOfAllBoxAmountModalOpen: (state, action) => {
            state.sumOfAllBoxAmountModalOpen = action.payload
        },
        setFeeData: (state, action) => {
            state.feeData = action.payload
        },
        setChangeScheduleDateForAllVendor: (state, action) => {
            state.changeScheduleDateForAllVendor = action.payload
        },
        setPrepayModalOpen: (state, action) => {
            state.prepayModalOpen = action.payload
        },
        setSubmitForThisPayerModal: (state, action) => {
            state.submitForThisPayerOpen = action.payload
        },
        setSubmitFormFees: (state, action) => {
            state.submitFormFees = action.payload
        },
        setLoadFormsDataState: (state, action) => {
            state.loadFormsDataState = action.payload
        },
        setSubmitFormForMultiplePayers: (state, action) => {
            state.submitFormForMultiplePayers = action.payload
        },
        setCategorisedFormFields: (state, action) => {
            state.categorisedFormFields = action.payload
        },
        setSubmitForThisPayerWarningModal: (state, action) => {
            state.submitForThisPayerWarningModal = action.payload
        },
        setSubmitForThisPayerReviewedCheckboxModal: (state, action) => {
            state.submitForThisPayerReviewedCheckboxModal = action.payload;
        },
        setSubmitForThisPayerReviewedCheckbox: (state, action) => {
            state.submitForThisPayerReviewedCheckbox = action.payload;
        },
        setAssignFormsToReviewersModal: (state, action) => {
            state.assignFormsToReviewersModal = action.payload;
        },
        setRecipientName: (state, action) => {
            state.recipientName = action.payload;
        },
        setRecipientTIN: (state, action) => {
            state.recipientTIN = action.payload;
        },
        setFormDetailsDrawerLoader: (state, action) => {
            state.formDetailsDrawerLoader = action.payload;
        },
        setFormDetailsDrawerTinMatchCheckbox: (state, action) => {
            state.formDetailsDrawerTinMatchCheckbox = action.payload;
        },
        setCheckFor1094cStatus: (state, action) => {
            state.checkFor1094cStatus = action.payload;
        },
        setOpen1094cModal: (state, action) => {
            state.open1094cModal = action.payload;
        },
        setOpen2023PaymentModal: (state, action) => {
            state.open2023PaymentModal = action.payload;
        },
        updateForm1094cStatusObj: (state, action) => {
            state.form1094cStatusObj = {
                ...state.form1094cStatusObj,
                ...action.payload,
            };
        },
        setSubmitForRecipientPendingModal: (state, action) => {
            state.submitForRecipientPendingModal = action.payload;
        },
        setShouldGetSubmittedFormsGridData: (state, action) => {
            state.shouldGetSubmittedFormsGridData = action.payload;
        },
        setEnableScheduleDate: (state, action) => {
            state.enableScheduleDate = action.payload;
        },
        setIsFormGridLoading: (state, action)=>{
            state.isFormGridLoading = action.payload;
        },
        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PRE_LOADING, message: "" },
        filtersLoadingState: { state: PAGE_STATE.PRE_LOADING, message: "" },
        isFormGridLoading: false,
        formDetailsDrawerLoader: { state: PAGE_STATE.PRE_LOADING, message: "" },

        selectedReadyToSubmitForms: [],
        formsList: [],
        selectedForm: { label: "", value: "" },
        highlightedForm: {},
        formDetails: {},
        feeData: {},

        taxYearsList: [],
        selectedTaxYear: { label: "", value: "" },

        payersList: [],
        selectedPayer: { label: "", value: "" },

        formType: { label: "Regular", value: "" },
        formStatus: { label: "", value: "" },
        fillingType: { label: "", value: "" },
        formDetailsDrawerTinMatchCheckbox: false,

        submittedFormsDetails: { RecordCount: {} },
        submittedForms: [],
        paginationState: {
            sort: null,
            page: 1,
            pageSize: 20,
            jsonPreferences: null,
            Skip: 0,
            total: 10,
            filter: "",
            IdNumber: "",
        },
        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },

        //modals
        calculateTaxFeeModalOpen: false,
        deleteFormsModal: {
            state: false,
            fromDrawer: false,
        },
        fromDetailsDrawerOpen: false,
        sumOfAllBoxAmountModalOpen: false,
        changeScheduleDateForAllVendor: false,
        prepayModalOpen: false,
        submitForThisPayerOpen: false,
        submitFormForMultiplePayers: false,
        submitForThisPayerWarningModal: false,
        submitForThisPayerReviewedCheckboxModal: false,
        assignFormsToReviewersModal: false,
        submitForRecipientPendingModal: false,

        //checkboxes
        readyToSubmitTabCheckboxes: {
            selectAllCheckBox: false,
            uspsMailCheckbox: false,
            emailRecipientCheckbox: false,
            tinMatchCheckbox: false,
            stateFilingCheckbox: false,
        },
        isTINHidden: true,

        submitFormFees: {},
        loadFormsDataState: { state: false, type: "" },
        categorisedFormFields: {},
        submitForThisPayerReviewedCheckbox: false,
        recipientName: "",
        recipientTIN: "",
        open1094cModal: false,
        form1094cStatusObj: {
            isAvailable: false,
            formStatus: null,
        },
        checkFor1094cStatus: false,
        open2023PaymentModal: false,
        shouldGetSubmittedFormsGridData: {
            gridData: false,
            updatePagination: false,
        },

        enableScheduleDate: false,
    }
})

export const { 
    setLoadingState, 
    setFiltersLoadingState,
    setIsFormGridLoading,
    setSubmitForRecipientPendingModal, 
    setFormsList, 
    setTaxYearsList, 
    setPayersList, 
    setFormType, 
    setFormStatus, 
    setFillingType, 
    setSubmittedForms, 
    setSelectedForm, 
    setSelectedTaxYear, 
    setSelectedPayer, 
    setPaginationState, 
    setCalculateTaxFeeModalOpen, 
    setSelectedForms, 
    setIsCheckBoxChecked, 
    setIsAllCheckBoxChecked, 
    setDeleteFormsModalOpen, 
    setFormDetailsDrawerOpen, 
    setHighlightedForm, 
    setFormDetails, 
    setSubmittedFormsDetails, 
    setReadyToSubmitTabCheckboxes, 
    setSumOfAllBoxAmountModalOpen, 
    setFeeData, 
    setChangeScheduleDateForAllVendor, 
    setPrepayModalOpen, 
    setSubmitForThisPayerModal, 
    setSubmitFormFees, 
    setSubmitFormForMultiplePayers, 
    setLoadFormsDataState, 
    setCategorisedFormFields, 
    setSubmitForThisPayerWarningModal, 
    setSubmitForThisPayerReviewedCheckboxModal, 
    setSubmitForThisPayerReviewedCheckbox, 
    setAssignFormsToReviewersModal, 
    setRecipientName, 
    setRecipientTIN, 
    setFormDetailsDrawerLoader, 
    setFormDetailsDrawerTinMatchCheckbox, 
    setOpen1094cModal, 
    updateForm1094cStatusObj, 
    setCheckFor1094cStatus, 
    setViewTin,
    setOpen2023PaymentModal,
    setShouldGetSubmittedFormsGridData,
    setEnableScheduleDate,
    setPayerDropdownPagination
 } = actions;
